import { Hint } from '@/Ship/Components/Hint'

/**
 * Підказка над «Курсами валют» (`SPEC-007` §12, `settings.currency-rates.import`).
 *
 * «08:00» — година розкладу імпорту на беку
 * (`ScheduleCurrencyRateImportCommand::SCHEDULE_HOUR`); пару тримає вартовий
 * «числа в підказках збігаються з константами беку».
 */
export const CurrencyRateImportHint = () => (
    <Hint id="settings.currency-rates.import">
        Щодня після 08:00 за Києвом система завантажує з НБУ курси EUR і USD до гривні, а також зворотні до них.
        Кнопка «Імпорт курсів валют» робить те саме вручну.
    </Hint>
)
